// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Transport = {
    http: () => {
        return {
            type: "http",
            _visit: function (visitor) {
                return FernIr.Transport._visit(this, visitor);
            },
        };
    },
    grpc: (value) => {
        return Object.assign(Object.assign({}, value), { type: "grpc", _visit: function (visitor) {
                return FernIr.Transport._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "http":
                return visitor.http();
            case "grpc":
                return visitor.grpc(value);
            default:
                return visitor._other(value);
        }
    },
};
